'use strict';
import React, { Component } from 'react';
import { GenericSimpleButton, GenericIconButton } from 'com-gyf-webcore-userinterfacecomponents';
import BotonEliminar from './BotonEliminar.jsx';

class Headers extends Component {
    constructor(props) {
        super(props);

        this.state = {
            routeToNuevoProducto: props.routeToNuevoProducto,
            data: props.data
        };

        this.routeToNuevoProducto = this.routeToNuevoProducto.bind(this);
    }

    routeToNuevoProducto() {
        this.state.routeToNuevoProducto();
    }

    componentWillReceiveProps(nextProps) {
        this.state.data = nextProps.data;
    }

    render() {
        let functions = this.props.data.user_functions || [];
        let alta = (functions.find(x => x.Codigo_Funcion == "Alta") != undefined);
        let baja = (functions.find(x => x.Codigo_Funcion == "Baja") != undefined);
        return (<div className="col-md-12">
            <h1>Productos</h1>
            <ul className="list-inline">
                {alta &&
                    <li>
                        <GenericSimpleButton
                            id="btnRoute"
                            text="Nuevo"
                            buttonClass="btn btn-primary btn-cta"
                            onClick={this.routeToNuevoProducto} />
                    </li>}
            </ul>
        </div>);
    }
}

export default Headers;